import styled from 'styled-components';

export const StyledCreatTeamModal = styled.div`
  width: 100%;

  .flex-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;

    .description {
      display: none;
      position: absolute;
      left: 40%;
      padding: 5px;
      border-radius: 5px;
      border: 1px solid rgba(157, 157, 157, 0.2);
      background-color: var(--white);
    }

    &:hover {
      .description {
        display: block;
      }
    }

    &.tag-section {
      justify-content: space-between;

      .tag-text {
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        padding: 5px 10px;
        border-radius: 10px;
        border: 1px solid rgb(157, 157, 157);
        text-transform: capitalize;
      }
    }
  }

  .react-select__multi-value__label {
    .tag-text {
      display: none;
    }
  }

  .react-select__single-value {
    .flex-wrap > .description {
      display: none;
    }
  }

  .header {
    width: 100%;
    margin: 0 0 20px;
    padding: 0 0 15px;
    border-bottom: 1px solid #cdcdcd;

    .heading {
      display: block;
      font-size: 20px;
      line-height: 24px;
    }
  }

  .title {
    display: block;
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 8px;
    color: var(--text-color);
  }

  .column-wrap {
    display: flex;
    gap: 20px;
    margin: 0 0 20px;
    position: relative;

    .column {
      width: 49%;
      flex-grow: 1;
    }
  }

  .team-members {
    position: relative;

    .team-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      .btn-add {
        border: 0;
        outline: none;
        box-shadow: none;
        padding: 0;
        font-size: 22px;
        color: var(--text-color);
      }
    }

    .input-wrap {
      display: flex;
      gap: 15px;
      position: relative;

      &:hover {
        .btn-close {
          display: block;
        }
      }

      .btn-close {
        display: none;
        position: absolute;
        bottom: 20px;
        right: 5px;
        font-size: 18px;
        cursor: pointer;
        z-index: 2;
      }

      > div {
        width: 50%;
        flex-grow: 1;
      }
    }
  }

  .item-holder {
    width: 100%;
    /* margin: 0 0 20px; */
    color: var(--light-gray);

    .react-select__control {
      padding-left: 4px;
    }

    .title {
      font-weight: 400;
    }

    p {
      margin: 0 0 20px;
    }
  }

  .react-select__control {
    padding-left: 10px;
  }

  .web-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    margin: 0 0 10px;

    .text-box {
      display: flex;
      align-items: center;
      gap: 6px;

      .icon {
        flex-shrink: 0;
        font-size: 20px;
        line-height: 1;
        color: var(--light-gray);
      }
      .text {
        display: block;
        color: var(--text-color);
      }
    }

    .btn {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 36px;
      border-radius: 10px;
      background: rgba(26, 42, 108, 0.1);
    }
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding-top: 15px;
    border-top: 1px solid #cdcdcd;
  }

  label {
    position: relative;
  }

  .btn-prompt {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 18px;
    line-height: 1;
    width: 28px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      background: var(--gray-100);
    }
  }

  .btn-domain {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    line-height: 18px;
    line-height: 1;
    border-radius: 5px;
    padding: 5px;
    cursor: pointer;
    &:hover {
      background: var(--gray-100);
    }
  }
`;
